<template>
  <div class="houseHoldInfo">
    <el-card>
        <div class="jump-btn">
          <el-button type="primary" @click="back">返回APP住户管理</el-button>
        </div>
        <el-form ref="formdisable" :model="formdisable" :label-width="require('@/config/enum').c_w5" :label-suffix="require('@/config/enum').c_colon">
          <!-- 用户名 -->
          <el-form-item :label="$t('lang.lab_username')" prop="name">
            <el-input v-model="formdisable.name" :disabled='true' :placeholder= this.row.nickName class="inputdis"></el-input>
          </el-form-item>
          <!-- 手机 -->
          <el-form-item :label="$t('lang.lab_phone')" prop="tele">
            <el-input v-model="formdisable.tele" :disabled='true' :placeholder= this.row.mobile class="inputdis"></el-input>
          </el-form-item>
          <!-- 小区 --> 
          <el-form-item :label="$t('lang.lab_village')" prop="village">
            <el-input v-model="formdisable.village" :disabled='true' :placeholder= this.row.garden.name class="inputdis"></el-input>
          </el-form-item>
          <!-- 楼号 -->
          <el-form-item :label="$t('lang.lab_buildingnum')" prop="houseId">
            <el-input v-model="formdisable.house" :disabled='true' :placeholder= this.row.garden.grids.houseName class="inputdis"></el-input>
          </el-form-item>
          <!-- 单元号 -->
          <el-form-item :label="$t('lang.lab_unitnum')" prop="unitId">
            <el-input v-model="formdisable.unitId" :disabled='true' :placeholder= this.row.garden.grids.unitName class="inputdis"></el-input>
          </el-form-item>
          <!-- 房间号 -->
          <el-form-item :label="$t('lang.lab_roomnum')" prop="roomId">
            <el-input v-model="formdisable.roomId" :disabled='true' :placeholder= this.row.garden.grids.roomName class="inputdis"></el-input>
          </el-form-item>
          <!-- 身份 -->
          <el-form-item :label="$t('lang.lab_identitynum')" prop="identity" v-if="this.row.garden.userType ===1">
            <el-input v-model="formdisable.identity" :disabled='true' :placeholder= "this.$i18n.t('lang.APPHOUSEHOLDMANAGE.USERTYPE[1].label')" class="inputdis"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_identitynum')" prop="identity" v-if="this.row.garden.userType ===2">
            <el-input v-model="formdisable.identity" :disabled='true' :placeholder= "this.$i18n.t('lang.APPHOUSEHOLDMANAGE.USERTYPE[2].label')" class="inputdis"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_identitynum')" prop="identity" v-if="this.row.garden.userType ===3">
            <el-input v-model="formdisable.identity" :disabled='true' :placeholder= "this.$i18n.t('lang.APPHOUSEHOLDMANAGE.USERTYPE[3].label')" class="inputdis"></el-input>
          </el-form-item>
          <!-- 标签 -->
          <el-form-item :label="$t('lang.lab_tags')" v-if="this.row.drawUserGarden">
            <el-tag v-for="(item,index) in (this.row.drawUserGarden).split(',')" :key="index" type="" style="margin-right:10px;">{{item}}</el-tag>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_tags')" v-if="this.row.draw&&this.row.drawUserGarden==''">
            <el-tag v-for="(item,index) in (this.row.draw).split(',')" :key="index" type="" style="margin-right:10px;">{{item}}</el-tag>
          </el-form-item>
        </el-form>
      </el-card>
      <el-card v-if="doors.length != 0 || lifts.length != 0">
        <el-form ref="formable" :model="formable" :rules="rules" :label-width="require('@/config/enum').c_w6" :label-suffix="require('@/config/enum').c_colon">
          <!-- 门禁权限 -->
          <el-form-item :label="$t('lang.lab_accessAuthority')" prop="doorDeviceId" v-if="doors.length != 0">
            <el-select 
              class="multiple-select"
              id='doorDeviceId'
              v-model="formable.doorDeviceId" 
              :placeholder="$t('lang.lab_please_Select') + $t('lang.lab_accessAuthority')"
              multiple
              filterable
              clearable
              @change="doorchange"
              >
              <el-option :key="doorDeviceKey" :label="$t('lang.lab_allDoorDevicedId')" :value=0></el-option>
              <el-option v-for="item in doors" :key="item.id" :label="item.doorName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <!-- 门禁有效期 -->
          <el-form-item :label="$t('lang.lab_accessControlPeriod')" prop="doorEndDate" v-if="doors.length != 0">
            <el-date-picker 
              class="authority" 
              v-model="formable.doorEndDate" 
              type="date"
              value-format='timestamp'
              :placeholder="$t('lang.lab_selectDeadlineTime')" >
            </el-date-picker>
          </el-form-item>
          <!-- 电梯权限 -->
          <el-form-item :label="$t('lang.lab_elevatorPermissions')" prop="liftId" v-if="lifts.length != 0">
            <el-select 
              class="multiple-select"
              id='liftId'
              v-model="formable.liftId" 
              :placeholder="$t('lang.lab_please_Select') + $t('lang.lab_elevatorPermissions')"
              multiple
              filterable
              clearable
              @change="elevatorchange"
              >
              <el-option :key="liftKey" :label="$t('lang.lab_allLiftId')" :value=0></el-option>
              <el-option v-for="items in lifts" :key="items.id" :label="items.name" :value="items.id"></el-option>
            </el-select>
          </el-form-item>
          <!-- 电梯有效期 -->
          <el-form-item :label="$t('lang.lab_elevatorAuthority')" prop="liftEndDate" v-if="lifts.length != 0">
            <el-date-picker 
              class="authority" 
              v-model="formable.liftEndDate" 
              type="date" 
              value-format='timestamp'
              :placeholder="$t('lang.lab_selectDeadlineTime')">
            </el-date-picker>
          </el-form-item>
          <!-- 电梯地下权限 -->
          <el-form-item :label="$t('lang.lab_elevatorAccess')" v-if="lifts.length != 0">
            <el-checkbox-group v-model="formable.basementFloor">
              <el-checkbox label="-1"></el-checkbox>
              <el-checkbox label="-2"></el-checkbox>
              <el-checkbox label="-3"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-button  :disabled="isDisabled" type="primary" class="btn-first" @click="save('formable')">{{$t('lang.btn_save')}}</el-button>
          <el-button  v-if="this.row.starHouseOwner === 1" type="primary" class="btn-first" @click="setStar(row.id,0)">{{$t('lang.lab_celStarHouseOwner')}}</el-button>
          <el-button  v-else type="primary" class="btn-first" @click="setStar(row.id,1)">{{$t('lang.lab_setStarHouseOwner')}}</el-button>
        </el-form>
      </el-card> 
  </div>
</template>

<script>
/**
 *@ClassName:houseHoldInfo
 *@Description:app住户管理
 *@author:李斌
 *@Copyright:格众科技
 *@date:2020-03-23
 */
export default {
   data() {
      var doorDate = (rule, value, callback) => {
        console.log(this.formable.doorDeviceId, value)
        if (this.formable.doorDeviceId && this.formable.doorDeviceId.length > 0 && (value === undefined || value === null)) {
          callback(new Error(this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_accessControlPeriod')))
        } else {
          callback()
        }
      }
      var liftDate = (rule, value, callback) => {
          if (this.formable.liftId && this.formable.liftId.length > 0 && (value === undefined || value === null)) {
            callback(new Error(this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_elevatorAuthority')))
          } else {
            callback()
          }
        }  
      return {
        isDisabled: true, // 确定按钮置灰
        saveData: '',
        add: 0, // 调用接口时监听
        doorDeviceKey: '',
        liftKey: '',
        row: '', // 接收列表页面的参数
        dooroldsearchUnit: [], // 门禁选择变化
        liftoldsearchUnit: [], // 电梯选择变化
        doors: [], // 所有门禁
        lifts: [], // 所有电梯
        formdisable: {
          name: '', // 用户名
          tele: '', // 手机
          village: '', // 小区
          houseId: '', // 楼号
          unitId: '', // 单元号
          roomId: '', // 房间号
          identity: '' // 身份
        },
        formable: {
          doorDeviceId: [], // 门禁权限（v-model）     
          doorEndDate: '', // 门禁有效期
          liftId: [], // 电梯权限（v-model）
          liftEndDate: '', // 电梯有效期
          basementFloor: [], // 电梯地下权限
        },
        rules: {
          doorEndDate: [{ required: true, validator: doorDate, trigger: 'blur' }],
          liftEndDate: [{ required: true, validator: liftDate, trigger: 'blur' }]
        },
      }
    },
    created() {
      // 初始化接收数据
      this.row = this.$route.query.row
      // 获取门禁列表
      this.doorDeviceList()
      // 获取电梯列表
      this.liftList()
    },
    watch: {
      add() {
        if (this.add === 2) {
          this.saveData = JSON.stringify(this.formable)
        }
      },
      formable: {
        handler(newVal, oldVal) {
          // 排序门禁id
          if (newVal.doorDeviceId) {
            for (let i = 0; i < newVal.doorDeviceId.length - 1; i++) {
              for (let j = 0; j < newVal.doorDeviceId.length - 1; j++) {
                if (newVal.doorDeviceId[j] > newVal.doorDeviceId[j + 1]) {
                  var tempdoorDeviceId = newVal.doorDeviceId[j]
                  newVal.doorDeviceId[j] = newVal.doorDeviceId[j + 1]
                  newVal.doorDeviceId[j + 1] = tempdoorDeviceId
                }
              }
            }
          }
          // 排序电梯id
          if (newVal.liftId) {
            for (let i = 0; i < newVal.liftId.length - 1; i++) {
              for (let j = 0; j < newVal.liftId.length - 1; j++) {
                if (newVal.liftId[j] > newVal.liftId[j + 1]) {
                  var templiftId = newVal.liftId[j]
                  newVal.liftId[j] = newVal.liftId[j + 1]
                  newVal.liftId[j + 1] = templiftId
                }
              }
            }
          }
          // 排序地下电梯权限
          if (newVal.basementFloor) {
            for (let i = 0; i < newVal.basementFloor.length - 1; i++) {
              for (let j = 0; j < newVal.basementFloor.length - 1; j++) {
                if (newVal.basementFloor[j] > newVal.basementFloor[j + 1]) {
                  var tempbasementFloor = newVal.basementFloor[j]
                  newVal.basementFloor[j] = newVal.basementFloor[j + 1]
                  newVal.basementFloor[j + 1] = tempbasementFloor
                }
              }
            }
          }
          // 监听按钮置灰
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            this.isDisabled = true
          } else {
            this.isDisabled = false
          }
          // 监听门禁有效期和电梯有效期的必填项
          if (this.formable.doorDeviceId.length > 0) {
            this.rules.doorEndDate[0].required = true
          } else {
            this.rules.doorEndDate[0].required = false
          }
          if (this.formable.liftId.length > 0) {
            this.rules.liftEndDate[0].required = true
          } else {
            this.rules.liftEndDate[0].required = false
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      back() {
        this.$router.push({
          name: 'appHouseholdManageList'
        })
      },
      doorDeviceRight() {
        let loading = this.$loading()
        this.$get(`/doorDeviceRight/?userId=${this.row.id}&type=1&gardenId=${this.row.garden.id}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              if (res.rightId != null) {
                this.formable.doorDeviceId = []
                var rightId = []
                rightId = res.rightId.split(',')
                // 去重
                let unique = []
                for (var i = 0; i < rightId.length; i++) {
                  if (unique.indexOf(rightId[i]) === -1) {
                    unique.push(rightId[i])
                  }
                }
                rightId = unique
                // 赋值
                for (let i = 0; i < rightId.length; i++) {   
                  for (let j = 0; j < this.doors.length; j++) {
                    if (rightId[i] == this.doors[j].id) {
                      // Bug #8473 2020-9-17 by shanll 
                       this.formable.doorDeviceId.push(parseInt(rightId[i]))
                    }
                  }             
                }
              }
              this.formable.doorEndDate = res.endDate
              this.add++
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )       
      },
      liftRight() {
        let loading = this.$loading()
        this.$get(`/liftRight/?userId=${this.row.id}&type=1`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              if (res.rightId != null) {
                this.formable.liftId = []
                var rightId = []
                rightId = res.rightId.split(',')
                // 去重
                let unique = []
                for (var i = 0; i < rightId.length; i++) {
                  if (unique.indexOf(rightId[i]) === -1) {
                    unique.push(rightId[i])
                  }
                }
                rightId = unique
                // 赋值
                for (let i = 0; i < rightId.length; i++) { 
                   for (let j = 0; j < this.lifts.length; j++) {
                    if (rightId[i] == this.lifts[j].id) {
                       // Bug #8473 2020-9-21
                       this.formable.liftId.push(parseInt(rightId[i]))
                    }
                  } 
                }
              }
              this.formable.liftEndDate = res.endDate
              if (res.basementFloor) {
                this.formable.basementFloor = res.basementFloor.split(',')
              }
              this.add++
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      doorDeviceList() { 
        let loading = this.$loading()
        let params = {
          garden: this.row.garden.id,
          userId: this.row.id,
          pageNo: 1,
          pageSize: 999
        }
        this.$get(`/doorDevice1/`, params).then(            
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.doors = res.list
              // 获取门禁
              this.doorDeviceRight()
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      liftList() {
        let params = {
            garden: this.row.garden.id,
            userId: this.row.id,
            pageNo: 1,
            pageSize: 999
        }
        let loading = this.$loading()
        this.$get(`/lift1/`, params).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.lifts = res.list
              // 获取电梯
              this.liftRight()
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
        // 门禁多选项
      doorchange(val) {   
        const allValues = []
        // 将全选"0"加入allValues
        allValues.push(0)
        for (const item of this.doors) {
          allValues.push(item.id)
        }
        // 用来储存上一次选择的值，可进行对比
        const oldVal = this.dooroldsearchUnit.length === 1 ? this.dooroldsearchUnit[0] : []
        // 若选择全部
        if (val.includes(0)) {
          this.formable.doorDeviceId = allValues
        }
        // 取消全部选中， 上次有， 当前没有， 表示取消全选
        if (oldVal.includes(0) && !val.includes(0)) {
          this.formable.doorDeviceId = []
        }
        // 新老数据都有全部选中,那就说明除了全选以外的被选择，所以去掉全选
        if (oldVal.includes(0) && val.includes(0)) {
          const index = val.indexOf(0)
          val.splice(index, 1)
          this.formable.doorDeviceId = val
        }
        // 全选未选，但是其他选项都全部选上了，则全选选上
        if (!oldVal.includes(0) && !val.includes(0)) {
          if (val.length === allValues.length - 1) {
            this.formable.doorDeviceId = [0].concat(val)
          }
        }
        // 储存当前选择的最后结果 作为下次的老数据
        this.dooroldsearchUnit[0] = this.formable.doorDeviceId
      },
      // 电梯多选项
      elevatorchange(val) {
        const allValues = []
        // 将全选"0"加入allValues
        allValues.push(0)
        for (const item of this.lifts) {
          allValues.push(item.id)
        }
        // 用来储存上一次选择的值，可进行对比
        const oldVal = this.liftoldsearchUnit.length === 1 ? this.liftoldsearchUnit[0] : []
        // 若选择全部
        if (val.includes(0)) {
          this.formable.liftId = allValues
        }
        // 取消全部选中， 上次有， 当前没有， 表示取消全选
        if (oldVal.includes(0) && !val.includes(0)) {
          this.formable.liftId = []
        }
        // 新老数据都有全部选中,那就说明除了全选以外的被选择，所以去掉全选
        if (oldVal.includes(0) && val.includes(0)) {
          const index = val.indexOf(0)
          val.splice(index, 1)
          this.formable.liftId = val
        }
        // 全选未选，但是其他选项都全部选上了，则全选选上
        if (!oldVal.includes(0) && !val.includes(0)) {
          if (val.length === allValues.length - 1) {
            this.formable.liftId = [0].concat(val)
          }
        }
        // 储存当前选择的最后结果 作为下次的老数据
        this.liftoldsearchUnit[0] = this.formable.liftId
      },
      // 设置取消明星业主
      setStar(id, flag) {
        let params = {
            gardenId: this.row.garden.id,
            userId: this.row.id
        }
        let loading = this.$loading()
        if (flag) {
          // 设置
          this.$get(`/usersSetStar/`, params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(res.errMsg)
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        } else {
          // 取消
          this.$get(`/usersClearStar/`, params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(res.errMsg)
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        }
      },
      save(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) { 
            if (this.formable.liftId.includes(0)) {
              this.formable.liftId.splice(0, 1)
            }  
            if (this.formable.doorDeviceId.includes(0)) {
              this.formable.doorDeviceId.splice(0, 1)
            }       
            let params = {
              'gardenId': this.row.garden.id,
              'houseId': this.row.garden.grids.houseId,
              'unitId': this.row.garden.grids.unitId,
              'doorDeviceId[]': this.formable.doorDeviceId.toString(),
              'doorEndDate': this.formable.doorEndDate,
              'liftId[]': this.formable.liftId.toString(),
              'liftEndDate': this.formable.liftEndDate,
              'basementFloor': this.formable.basementFloor.toString(),
            }
            let loading = this.$loading()
            this.$patch(`/users/${this.row.id}`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )        
          }
        })           
      }     
    }
}
</script>

<style lang= 'scss'>
.houseHoldInfo {
  .btn-first{
    width: 120px;
    margin-left: 20px;
  }
  .inputdis {
    width: 30%;
  }
  .authority{
    width: 30%;
  }
  .el-form{
    padding-top: 20px;
  }
  .el-card.is-always-shadow{
    margin-bottom: 20px;
  }
}
</style>